<template>
  <div>enterprises</div>
</template>

<script>
export default {
  name: "EnterprisesList"
}
</script>

<style>

</style>